module.exports = __webpack_public_path__ + "static/media/word_48x1.3eedc944.svg";